import { cachedUserDocumentsQuery } from '@atlassian/search-client/user-documents';
import { type RecommendedObject } from '@atlassian/search-client/user-documents/types';

export const fetchUserDocuments: (
	cloudId: string,
	userId: string,
	aggAbsoluteUrl: string | undefined,
	headers?: Record<string, string>,
) => Promise<
	{
		id: string;
		title: string;
		data: RecommendedObject;
		type: 'recommended-document';
	}[]
> = async (
	cloudId: string,
	userId: string,
	aggAbsoluteUrl: string | undefined,
	headers?: Record<string, string>,
) => {
	const response = await cachedUserDocumentsQuery({
		variables: {
			userId,
			tenantId: cloudId,
			caller: 'quick-find',
			maxNumberOfResults: 6,
		},
		aggAbsoluteUrl,
		onlyRefreshIfExpired: true,
		returnExpired: false,
		headers,
	});

	const recommendedObjects: RecommendedObject[] = response.data?.smarts?.recommendedObject || [];
	return recommendedObjects.filter((r) => Boolean(r.object)).map(mapEssentialData);
};

export const mapEssentialData: (result: RecommendedObject) => {
	id: string;
	title: string;
	data: RecommendedObject;
	type: 'recommended-document';
} = (result: RecommendedObject) => {
	return {
		id: result.id,
		title: result?.object?.title || '',
		data: result,
		type: 'recommended-document' as const,
	};
};
